<template>
  <vx-card class="Payslip-Reports">
    <div class="vx-col md:w-1/2 w-full mt-5">
      <span class="text-sm">Users</span><span style="color: red">*</span>
      <v-select
        v-validate="'required'"
        class="w-full"
        name="Users"
        v-model="selectedUser"
        label="fullName"
        :options="getusers"
        placeholder="Please Select"
        @input="handleUserSelection"
      />
      <span class="text-danger">{{ errors.first("Users") }}</span>
    </div>

    <div>
      <div
        class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row"
      >
        <div class="vx-col sm:w-1/5 md:w-1/5 lg:w-1/5 xl:w-1/5 w-full mb-2">
          <span class="text-sm">Payout Date </span
          ><span style="color: red">*</span>
          <v-select
            class="mb-3"
            v-model="payOutDate"
            name="payOutDate-name"
            :options="payOutDateList"
          />
          <vs-button
            class="download-Payslip"
            type="gradient"
            color="primary"
            @click="downloadPayslip()"
            icon-pack="feather"
            icon="icon-download"
            :disabled="this.payOutDate == null"
            >Download</vs-button
          >
        </div>
      </div>
    </div>
    <div>
      <div class="vx-col flex-1" id="account-info-col-2">
        <div
          id="div-with-loading"
          class="scroll-content ex1 vs-con-loading__container"
        >
          <input
            class="mb-3"
            v-show="payOutDate != null"
            v-model.number="page"
            type="number"
            style="
              width: 3em;
              padding: 0.3rem;
              font-size: 1rem;
              border: 1px solid rgba(0, 0, 0, 0.2);
            "
          />
          <span class="text-sm" style="color: white"> / {{ numPages }}</span>
          <div
            v-if="loadedRatio > 0 && loadedRatio < 1"
            style="background-color: green; color: white; text-align: center"
            :style="{ width: loadedRatio * 100 + '%' }"
          >
            {{ Math.floor(loadedRatio * 100) }}%
          </div>
          <pdf
            class="overflow-hidden"
            ref="pdf"
            style="display: inline-block; width: 100%"
            :src="linkURL"
            :page="page"
            @password="password"
            @error="error"
            @progress="handleProgress"
            @page-loaded="handlePageLoaded"
            @num-pages="numPages = $event"
            @link-clicked="page = $event"
          >
          </pdf>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment";
import Swal from "sweetalert2";
import pdf from "vue-pdf";

export default {
  data() {
    return {
      page: 1,
      numPages: 0,
      selectedUser: null,
      id: null,
      fullName: "",
      loadedRatio: 0,
      payOutDateList: [],
      payOutDate: null,
      linkURL: "",
      pdfData: null,
      pdfFileName: null,
    };
  },
  components: {
    pdf,
    "v-select": vSelect,
  },
  computed: {
    getusers() {
      return this.$store.state.hrms.allEmployee;
    },
    convertPayOutDate() {
      return (d) => {
        var dt = moment(d, "YYYYMMDD");
        return dt.format("DD-MMM-YYYY");
      };
    },
  },
  watch: {
    selectedUser() {
      // Call the method to format the user ID

      this.UserId();
    },

    payOutDate() {
      this.linkURL = null;
      this.loadingTask();
    },
    page() {
      if (this.page <= 0) this.page = 1;
      else if (this.numPages > 0 && this.page > this.numPages) {
        this.page = this.numPages;
      }
    },
  },
  methods: {
    UserId() {
      // Check if selectedUser and userId exist
      if (this.selectedUser && this.selectedUser.id) {
        // Assign the raw user ID to the formattedUserId
        this.uid = this.selectedUser.id;

        // Reset payOutDate when a user is selected
        this.payOutDate = null;
      } else {
        this.uid = null; // Handle the case where there is no selected user or user ID
      }
    },
    handleUserSelection() {
      if (this.selectedUser && this.selectedUser.id) {
        this.uid = this.selectedUser.id;
        this.getPaylipList(); // Call getPaylipList when user is selected
      } else {
        this.uid = null;
      }
    },
    getPaylipList() {
      this.payOutDateList = [];
      this.$vs.loading();

      try {
        if (!this.selectedUser) {
          throw new Error("selectedUser is null or undefined.");
        }

        if (
          this.selectedUser.id === undefined ||
          this.selectedUser.id === null
        ) {
          throw new Error("selectedUser does not have an id property.");
        }

        const userId = String(this.selectedUser.id);

        this.$store
          .dispatch("getPayslipList", userId)
          .then((response) => {
            let p = response.data;
            p.forEach((payOutDate) => {
              this.payOutDateList.push(
                this.convertPayOutDate(payOutDate.substr(payOutDate.length - 8))
              );
            });
            this.$vs.loading.close();
          })
          .catch((error) => {
            console.error("Error fetching pay slip list:", error);
            this.$vs.loading.close();
          });
      } catch (error) {
        console.error("Error in getPaylipList:", error.message);
        this.$vs.loading.close();
      }
    },

    loadingTask() {
      this.linkURL = null;
      this.pdfData = null;
      this.pdfFileName = null;
      this.loadedRatio = 0;
      this.numPages = 0;
      this.page = 1;

      if (this.payOutDate != null) {
        const data = {
          userId: this.selectedUser ? this.selectedUser.id : null,
          payOutDate: moment(this.payOutDate).format("YYYYMMDD"),
          responseType: "arraybuffer",
          timeout: 60000,
        };

        this.showPdfLoading();
        this.$store
          .dispatch("getViewPayslip", data)
          .then((response) => {
            this.pdfData = new Uint8Array(response.data);
            const signature = String.fromCharCode.apply(
              null,
              this.pdfData.slice(0, 5)
            );

            if (signature !== "%PDF-") {
              throw new Error("The server did not return a valid PDF file.");
            }

            this.pdfFileName = this.getContentDispositionFileName(
              response.headers["content-disposition"]
            );
            this.linkURL = this.pdfData;
          })
          .catch((error) => {
            this.linkURL = null;
            this.closePdfLoading();
            this.$alert(error.message || error, "Error", "error");
          });
      }
    },
    // password: function (updatePassword, reason) {
    //   Swal.fire({
    //     title: "Enter your password",
    //     input: "password",
    //     inputLabel: "Password",
    //     inputPlaceholder: "Max of 10 characters",
    //     inputAttributes: {
    //       maxlength: 50,
    //       autocapitalize: "off",
    //       autocorrect: "off",
    //       showCancelButton: true,
    //     },
    //   })
    //     .then((t) => {
    //       if (t.isConfirmed) {
    //         updatePassword(t.value);
    //         if (t.value == "") return;
    //         this.$vs.loading({
    //           container: "#div-with-loading",
    //           scale: 0.6,
    //         });
    //         setTimeout(() => {
    //           this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    //         }, 2000);
    //       } else {
    //         Swal.fire("View Payslip", "Cancelled", "warning");
    //         this.$router.go();
    //       }
    //     })
    //     .catch(() => {
    //       Swal.fire("Payslip not loaded", "Cancelled", "warning");
    //     });
    // },
    password(updatePassword, reason) {
      // PDF.js uses reason 1 when it first needs a password and reason 2 when
      // the supplied password was rejected.
      if (
        reason !== 2 &&
        this.selectedUser &&
        this.selectedUser.lastName &&
        this.selectedUser.employeeCode
      ) {
        const password = `${this.selectedUser.lastName}${this.selectedUser.employeeCode}`
          // Keep this normalization aligned with ReportsController.setPDFPassword.
          .replace(/[\s,.]/g, "")
          .toLowerCase();
        updatePassword(password);
        return;
      }

      Swal.fire({
        title: reason === 2 ? "Incorrect payslip password" : "Enter payslip password",
        input: "password",
        inputLabel: "Password",
        inputPlaceholder: "Enter the PDF password",
        showCancelButton: true,
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          updatePassword(result.value);
        } else {
          this.closePdfLoading();
        }
      });
    },
    error: function (err) {
      this.closePdfLoading();
      this.$alert(err, "Error", "error");
    },

    handlePageLoaded() {
      this.loadedRatio = 1;
      this.closePdfLoading();
    },

    handleProgress(loadedRatio) {
      this.loadedRatio = loadedRatio;
      if (loadedRatio >= 1) this.closePdfLoading();
    },

    showPdfLoading() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.6,
      });
    },

    closePdfLoading() {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },

    getContentDispositionFileName(contentDisposition) {
      if (!contentDisposition) return null;

      const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
      return fileNameMatch ? fileNameMatch[1] : null;
    },

    downloadPayslip() {
      if (!this.pdfData) {
        this.$alert("The payslip has not finished loading.", "Download Error", "error");
        return;
      }

      this.$vs.loading();
      const userId = this.selectedUser
        ? this.selectedUser.id
        : "unknownUserId";
      const payoutDate = this.payOutDate
        ? moment(this.payOutDate).format("YYYYMMDD")
        : "unknownPayoutDate";
      const fileName = this.pdfFileName || `${userId}_${payoutDate}.pdf`;
      const blob = new Blob([this.pdfData], { type: "application/pdf" });
      const link = document.createElement("a");

      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
      this.$vs.loading.close();
    },
  },
};
</script>

<style>
div.ex1 {
  background-color: #888888;
  width: 100%;
  overflow: auto;
  border: 1px solid;
  padding: 10px;
  border-radius: 5px 0px 0px 5px;
}

.Payslip-Reports {
  text-align: center;
}

.Payslip-Reports .vx-col {
  width: 100%;
  margin: 0 auto; /* Center the column horizontally */
}

.Payslip-Reports .vx-row {
  width: 100%;
}
.download-Payslip {
  display: flex;
  margin: 0 auto;
}
.vs__dropdown-menu {
  max-height: 200px;
}

.Payout-Date-Vselect {
  width: 20%;
  padding-right: 20px;
}

@media (max-width: 630px) {
  .Payout-Date-Vselect {
    width: 70%;
  }
}
</style>
